<template>
  <div>
    <div v-if="this.$store.state.device.isDesktop">
      <navbarTop></navbarTop>
      <sideBar></sideBar>
      <div class="desktop_container">
        <div class="input-group" style="padding-bottom: 25px;" v-if="width>800">
          <div style="width: 78%; margin-right: 2%;">
            <input
                    v-model="searchQuery"
                    type="text"
                    placeholder="Search number"
                    class="form-control"
                    style="border-radius: 32px; padding-left: 60px;"
            />
            <i style="position: absolute; left: 20px; top: 12px; color: #2B2D42; z-index: 100;" class="fas fa-search"></i>
            <i v-if="this.searchQuery.length>0" v-on:click="clear" style="position: absolute; right: 26%; top: 12px; color: #2B2D42; z-index: 100;" class="fas fa-times"></i>
          </div>
          <div style="width: 20%;">
            <img src="../../public/img/filter.svg" style="position: absolute; right: 15%; top: 10px; color: #2B2D42; z-index: 900;" class="fas fa-search">
            <b-form-select class="btnFilter" v-model="selected" :options="options"></b-form-select>
          </div>
        </div>
        <div class="input-group" style="padding-bottom: 25px;" v-else>
          <div style="width: 68%; margin-right: 2%;">
            <input
                    v-model="searchQuery"
                    type="text"
                    placeholder="Search number"
                    class="form-control"
                    style="border-radius: 32px; padding-left: 60px;"
            />
            <i style="position: absolute; left: 20px; top: 12px; color: #2B2D42; z-index: 100;" class="fas fa-search"></i>
            <i v-if="this.searchQuery.length>0" v-on:click="clear" style="position: absolute; right: 36%; top: 12px; color: #2B2D42; z-index: 100;" class="fas fa-times"></i>
          </div>
          <div style="width: 30%;">
            <img src="../../public/img/filter.svg" style="position: absolute; right: 20%; top: 10px; color: #2B2D42; z-index: 900;" class="fas fa-search">
            <b-form-select class="btnFilter" v-model="selected" :options="options"></b-form-select>
          </div>
        </div>

        <section>
          <b-table
                  :data="filteredData"
                  ref="table"
                  paginated
                  :per-page="rows_per_page"
                  aria-next-label="Next page"
                  aria-previous-label="Previous page"
                  aria-page-label="Page"
                  aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="number" :label="$t('pages.PaymentsList.ColumnNumber')">
                {{ props.row.number }}
              </b-table-column>

              <b-table-column field="name" :label="$t('pages.PaymentsList.ColumnName')">
                {{ props.row.name }}
              </b-table-column>

              <b-table-column :label="$t('pages.PaymentsList.ColumnPaymentDate')">
                {{ props.row.payment }}
              </b-table-column>

              <b-table-column :label="$t('pages.PaymentsList.ColumnValue')">
                {{ props.row.value }} €
              </b-table-column>

              <b-table-column centered :label="$t('pages.PaymentsList.ColumnStatus')" v-if="props.row.status == 1">
                <span class="tag is-success" style="border-radius: 32px;">{{ $t('pages.PaymentsList.Ok') }}</span>
              </b-table-column>

              <b-table-column centered :label="$t('pages.PaymentsList.ColumnStatus')" v-if="props.row.status == 2">
                <span class="tag is-danger" style="border-radius: 32px;">{{ $t('pages.PaymentsList.Delay') }}</span>
              </b-table-column>

              <b-table-column centered :label="$t('pages.PaymentsList.ColumnCancelPayment')">
                <a v-on:click="cancelPayment(props.row)"><i class="fa fa-times cancel"></i></a>
              </b-table-column>

            </template>
          </b-table>
        </section>
      </div>
    </div>
    <div style="width: 100%; height: 100%;" v-if="this.$store.state.device.isMobile">
      <navbarTop></navbarTop>
      <navbarBottom></navbarBottom>
      <div    class="container"
              style="padding: 80px 16px 50px;margin: auto">

        <div class="input-group" style="padding-bottom: 25px;">
          <div style="width: 58%; margin-right: 2%;">
            <input
                    v-model="searchQuery"
                    type="text"
                    placeholder="Search number"
                    class="form-control"
                    style="margin-right: 5px; border-radius: 32px;"
            />
            <i style="position: absolute; left: 15px; top: 12px; color: #2B2D42; z-index: 100;" class="fas fa-search"></i>
            <i v-if="this.searchQuery.length>0" v-on:click="clear" style="position: absolute; right: 150px; top: 12px; color: #2B2D42; z-index: 100;" class="fas fa-times"></i>
          </div>
          <div style="width: 40%;">
            <img src="../../public/img/filter.svg" style="position: absolute; right: 30%; top: 10px; color: #2B2D42; z-index: 100;" class="fas fa-search">
            <b-form-select class="btnFilter" v-model="selected" :options="options"></b-form-select>
          </div>
        </div>

        <section>
          <b-table
                  :data="filteredData"
                  ref="table"
                  paginated
                  :per-page="rows_per_page"
                  aria-next-label="Next page"
                  aria-previous-label="Previous page"
                  aria-page-label="Page"
                  aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="number" :label="$t('pages.PaymentsList.ColumnNumber')">
                {{ props.row.number }}
              </b-table-column>

              <b-table-column field="name" :label="$t('pages.PaymentsList.ColumnName')">
                {{ props.row.name }}
              </b-table-column>

              <b-table-column :label="$t('pages.PaymentsList.ColumnPaymentDate')">
                {{ props.row.payment }}
              </b-table-column>

              <b-table-column :label="$t('pages.PaymentsList.ColumnValue')">
                {{ props.row.value }} €
              </b-table-column>

              <b-table-column centered :label="$t('pages.PaymentsList.ColumnStatus')" v-if="props.row.status == 1">
                <span class="tag is-success" style="border-radius: 32px;">{{ $t('pages.PaymentsList.Ok') }}</span>
              </b-table-column>

              <b-table-column centered :label="$t('pages.PaymentsList.ColumnStatus')" v-if="props.row.status == 2">
                <span class="tag is-danger" style="border-radius: 32px;">{{ $t('pages.PaymentsList.Delay') }}</span>
              </b-table-column>

              <b-table-column centered :label="$t('pages.PaymentsList.ColumnCancelPayment')">
                <a v-on:click="cancelPayment(props.row)"><i class="fa fa-times cancel"></i></a>
              </b-table-column>

            </template>
          </b-table>
        </section>
      </div>
    </div>
  </div>
</template>


<script>
  import NavbarTop from "../components/navbarTop";
  import navbarBottom from "../components/navbarBottom";
  import sideBar from "../components/sideBar"
  import {getPayments, cancelPayment} from "../api/Payment/apiPayment.js";
  import "buefy/dist/buefy.css";
  const pt = require('../translations/pt-PT/pt-PT');
  const en = require('../translations/en-GB/en-GB');

  export default {
    name: "listPayments",
    components: {
      NavbarTop,
      navbarBottom,
      sideBar
    },
    data() {
      return {
        width: null,
        data: [],
        searchQuery: "",
        defaultOpenedDetails: [1],
        showDetailIcon: true,
        rows_per_page: 7,
        selected: null,
        options: [],
        value_default: null,
        value_elderly: null,
        value_child: null,
        value_athlete: null,
        value_woman: null
      };
    },
    methods: {
      clear() {
        this.searchQuery = '';
      },
      cancelPayment(row) {
        let spinner = this.$loading.open();

        let fee_value = null;
        if(row.type==1) fee_value=this.value_default;
        if(row.type==2) fee_value=this.value_elderly;
        if(row.type==3) fee_value=this.value_child;
        if(row.type==4) fee_value=this.value_athlete;
        if(row.type==5) fee_value=this.value_woman;
        let number_of_payments_year = row.value/fee_value;
        cancelPayment(row.id, {"number": row.number, "number_of_payments_year": -number_of_payments_year})
                .then(response => {
                  let members = JSON.parse(localStorage.getItem('members'));
                  for(var i=0; i<members.length; i++) {
                      if(members[i].number == row.number) {
                        members[i].number_of_payments_year -= number_of_payments_year;
                        //Calculate status
                        let month = new Date().getMonth()+1;
                        if(members[i].number_of_payments_year >= month) members[i].status = 1;
                        else members[i].status = 2;
                      }
                  }
                  localStorage.setItem('members', JSON.stringify(members));

                  spinner.close();
                  if(this.$i18n.locale()=='pt') {this.$toast.open(pt.pages.List.messageCancelPayment); this.$router.go(0);}
                  if(this.$i18n.locale()=='en') {this.$toast.open(en.pages.List.messageCancelPayment); this.$router.go(0);}
                })
                .catch(error => {
                  console.log(error);
                  spinner.close();
                  if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                  else{
                    let response_error = error.response.data;
                    this.$toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                  }
                });
      }
    },
    mounted() {
      this.width = Math.max(self.innerWidth || 0, document.documentElement.clientWidth || 0, document.body.clientWidth || 0);
      if(this.$store.state.device.isDesktop) this.rows_per_page = 7;
      let spinner = this.$loading.open();
      getPayments()
              .then(response => {
                for (var i in response.data.body){
                  response.data.body[i].number = response.data.body[i].number.toString();
                  let date = new Date(response.data.body[i].payment);
                  let year = date.getFullYear();
                  let month = date.getMonth()+1;
                  let dt = date.getDate();
                  let hour = date.getHours();
                  let min = date.getMinutes();
                  if (dt < 10) dt='0'+dt;
                  if (month < 10) month='0'+month;
                  if (min < 10) min='0'+min;

                  let formatted_date = dt+'-'+month+'-'+year+' '+hour+':'+min;
                  response.data.body[i].payment_filter_text = month+'-'+year;
                  response.data.body[i].payment_date = new Date(response.data.body[i].payment);
                  response.data.body[i].payment = formatted_date;
                  if(month=='01') response.data.body[i].payment_filter = new Date(date.setDate(31));
                  if(month=='02') response.data.body[i].payment_filter = new Date(date.setDate(27));
                  if(month=='03') response.data.body[i].payment_filter = new Date(date.setDate(31));
                  if(month=='04') response.data.body[i].payment_filter = new Date(date.setDate(30));
                  if(month=='05') response.data.body[i].payment_filter = new Date(date.setDate(31));
                  if(month=='06') response.data.body[i].payment_filter = new Date(date.setDate(30));
                  if(month=='07') response.data.body[i].payment_filter = new Date(date.setDate(31));
                  if(month=='08') response.data.body[i].payment_filter = new Date(date.setDate(31));
                  if(month=='09') response.data.body[i].payment_filter = new Date(date.setDate(30));
                  if(month=='10') response.data.body[i].payment_filter = new Date(date.setDate(31));
                  if(month=='11') response.data.body[i].payment_filter = new Date(date.setDate(30));
                  if(month=='12') response.data.body[i].payment_filter = new Date(date.setDate(31));
                }

                this.data = response.data.body;
                let options=[];
                let seenText = {};
                if(this.$i18n.locale()=='pt') options.push({ value: null, text: pt.pages.PaymentsList.Filter});
                if(this.$i18n.locale()=='en') options.push({ value: null, text: en.pages.PaymentsList.Filter });
                for(var i=0;i<this.data.length;i++){
                  options.push({ value: this.data[i].payment_filter, text: this.data[i].payment_filter_text });
                }
                this.options = options.filter(function(currentObject) {
                  if (currentObject.text in seenText) {
                    return false;
                  } else {
                    seenText[currentObject.text] = true;
                    return true;
                  }
                });

                spinner.close();
              })
              .catch(error => {
                spinner.close();
                if (!error.response) this.$toast.open({message: "Not connecting to server...", type: 'is-danger'});
                else this.$toast.open({message: "Something went wrong", type: 'is-danger'})
              });

      let spinner2 = this.$loading.open();
      this.$store.state.createSocio.values.then(response => {
          this.value_default = response.fee_value_default;
          this.value_elderly = response.fee_value_elderly;
          this.value_child = response.fee_value_child;
          this.value_athlete = response.fee_value_athlete;
          this.value_woman = response.fee_value_woman;
          spinner2.close();
      });
    },
    computed: {
      filteredData: function() {
        let spinner = this.$loading.open();

        var query = new RegExp(this.searchQuery, "i");
        var data = [];

        for (var i in this.data) {
          if (this.data[i].number.match(query)) {
            data.push(this.data[i]);
          }
        }

        var data_date_filter = [];
        if(this.selected!=null){
          for (var i in data) {
            if (data[i].payment_date < this.selected) {
              data_date_filter.push(data[i]);
            }
          }
        }else{data_date_filter=data}

        spinner.close();
        return data_date_filter;
      }
    }
  };
</script>

<style scoped>
  .cancel {
    color: #D0284C !important;
    font-size: 125% !important;
  }
  @media (max-width: 330px) {
    ::placeholder {
      font-size: 90%;
    }
    select {
      font-size: 14px;
    }
  }
  @media (max-width: 330px) {
    ::placeholder {
      font-size: 90%;
    }
  }
  .btnFilter {
    height: 100%;
    width: 100%;
    background: #2B2D42 0% 0% no-repeat padding-box;
    border-radius: 32px;
    color: white;
    border: none;
    letter-spacing: 0.85px;
    padding-left: 40%;
  }
  input {
    padding-left: 20%;
  }
</style>
